import React, { Component } from 'react';
import { compose } from '../../reactApolloCompat';
import { withRouter } from '../../utils/withRouter';
import withStyles from '@mui/styles/withStyles';
import Grid from '../../components/layout/Grid';
import Paper from '../../components/layout/Paper';
import ViewHeader from '../../components/header/ViewHeader';
import DataTable from '../../components/dataTable/DataTable';
import { getCurrentUser } from '../../environment';
import { cremationColumns, cremationFragment } from '../Cremation/CremationRecordList';

class RecentlyUpdated extends Component {
    render() {
        return (
            <Grid container>
                <Grid item>{this.renderHeader()}</Grid>
                <Grid item>
                    <Paper elevation={0}>{this.renderRecentOrders()}</Paper>
                </Grid>
            </Grid>
        );
    }

    renderHeader() {
        return <ViewHeader title="Your Recent Cremations" />;
    }

    renderRecentOrders() {
        const { ID } = getCurrentUser();
        const filters = [
            { field: 'RecentBy.ID', value: ID }
        ];
        return (
            <Grid container>
                <Grid item>
                    <DataTable
                        dataObject="CremationOrder"
                        queryName="readCremationOrders"
                        fragment={cremationFragment}
                        columns={cremationColumns}
                        variables={{ limit: 10, filters, filterBy: [] }}
                        isFilterable={['Status']}
                        // brandProperty="LegacyKey" //the property to determine the brand from
                        showFlags
                        noFiltersTitle="All Your Recent Cremations"
                    />
                </Grid>
            </Grid>
        );
    }
}

export default compose(withRouter, withStyles({}))(RecentlyUpdated);
